import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject } from '@angular/core';
import { Severity } from './constants';

export class LoggingService
{
  private http: HttpClient;
  private _loggingURL: string;

  constructor(@Inject(HttpClient) http: HttpClient)
  {
    this.http = http;
  }

  public log(origin: string, severity: string, message: string): void
  {
    if (this._loggingURL) {
      this.logToURL(origin, severity, message);
    }

    if (severity === Severity.WARNING) {
      console.warn(`${origin}: ${message}`);
    }
    else if (severity === Severity.ERROR) {
      console.error(`${origin}: ${message}`);
    }
  }

  public get loggingURL(): string
  {
    return this._loggingURL;
  }

  public set loggingURL(loggingURL: string)
  {
    this._loggingURL = loggingURL;
  }

  private logToURL(origin: string, severity: string, message: string): void
  {
    const headers = new HttpHeaders({
        'Content-Type': 'application/json',
    });
    const options = { headers: headers };
    const body = {
        component: origin,
        severity: severity,
        message: message,
    };

    this.http
        .post(this._loggingURL, body, options)
        .subscribe((data) => {}, (err) => {});
  }
}



// WEBPACK FOOTER //
// ./src/app/core/logging/logging.service.ts